/**
 * ModuleBranding — per-domain SEO branding.
 * Sets document.title, meta description and a coloured SVG favicon
 * for the current module host (hustleeats.au → "HustleEats" etc.).
 * Renders nothing; no effect on non-module hosts.
 */
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { getBrandHost } from "@/lib/moduleHost";

function svgFavicon(initials, color) {
  const svg = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64">
    <rect width="64" height="64" rx="14" fill="${color}"/>
    <text x="32" y="42" font-family="Arial,Helvetica,sans-serif" font-size="28"
          font-weight="800" fill="#0c0a09" text-anchor="middle">${initials}</text>
  </svg>`;
  return `data:image/svg+xml,${encodeURIComponent(svg)}`;
}

export const ModuleBranding = () => {
  const { pathname } = useLocation();
  const polishFoodies = /^\/sites\/polish-foodies(?:\/|$)/.test(pathname);

  useEffect(() => {
    const mod = getBrandHost();
    if (!mod) return;
    document.title = mod.title;
    let meta = document.querySelector('meta[name="description"]');
    if (!meta) {
      meta = document.createElement("meta");
      meta.setAttribute("name", "description");
      document.head.appendChild(meta);
    }
    meta.setAttribute("content", mod.desc);
    document.querySelectorAll('link[rel*="icon"]').forEach((l) => l.remove());
    const link = document.createElement("link");
    link.rel = "icon";
    link.type = "image/svg+xml";
    link.href = svgFavicon(mod.initials, mod.color);
    document.head.appendChild(link);
    // PWA: swap in the module-branded manifest + theme colour so the
    // installed app carries the right name/colour per domain.
    const manifest = document.querySelector('link[rel="manifest"]');
    if (manifest) manifest.href = `/api/pwa/manifest/${mod.key}`;
    const theme = document.querySelector('meta[name="theme-color"]');
    if (theme) theme.setAttribute("content", mod.color);
    const appleTitle = document.querySelector(
      'meta[name="apple-mobile-web-app-title"]');
    if (appleTitle) appleTitle.setAttribute("content", mod.title);
  }, []);
  useEffect(() => {
    if (!polishFoodies) return;
    const previous = Array.from(document.querySelectorAll('link[rel*="icon"]'));
    previous.forEach(link => link.remove());
    const icon = document.createElement("link");
    icon.rel = "icon";
    icon.type = "image/x-icon";
    icon.href = "/api/uploads/branding/polish-foodies/favicon.ico?v=adb4459b2609";
    document.head.appendChild(icon);
    return () => {
      icon.remove();
      previous.forEach(link => document.head.appendChild(link));
    };
  }, [polishFoodies]);
  return null;
};

export default ModuleBranding;
